import { a as g, j as a } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as e } from "../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import { b as u, f as k, T as y } from "../../../FeatureFlagProvider-CQds873Z.js";
const o = 18, l = 3, f = 9;
function O(m) {
  const {
    label: c,
    description: b,
    hasContainer: x = !1,
    value: n,
    isSelected: s,
    status: r = "enabled",
    hasTextField: p,
    onChange: v,
    groupName: d,
    "data-testid": h
  } = m, i = r === "disabled", t = r === "readOnly";
  function I() {
    r === "enabled" && v(n);
  }
  return /* @__PURE__ */ g("label", {
    "data-testid": h ? `${h}-${n}` : d ? `${d}-${n}` : void 0,
    css: {
      // Layout
      display: "flex",
      alignItems: "flex-start",
      gap: "var(--spacing-lg)",
      padding: "var(--spacing-lg)",
      // Background & Hover
      transition: "background-color 200ms ease",
      background: e.white200,
      ":hover": !i && !t ? {
        background: e.white300
      } : {},
      // Text
      ...u({
        color: i ? "slate300" : "black"
      }),
      cursor: i || t ? "not-allowed" : "pointer",
      // Border Emphasis
      ...x && {
        border: `1px solid ${e.blue500}`,
        borderRadius: "var(--spacing-base)"
      }
    },
    children: [/* @__PURE__ */ a("input", {
      name: d,
      type: "radio",
      value: n,
      checked: s,
      onChange: I,
      disabled: i,
      readOnly: t,
      "aria-label": c,
      css: {
        opacity: 0,
        position: "absolute"
      }
    }), /* @__PURE__ */ a("div", {
      css: {
        width: o + l * 2,
        // Total width 24px
        height: o + l * 2,
        // Total height 24px
        padding: l,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
      },
      children: /* @__PURE__ */ a("div", {
        css: {
          width: o,
          height: o,
          borderRadius: "50%",
          boxSizing: "border-box",
          border: `2px solid ${i ? e.slate300 : t ? e.black : e.blue500}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          transition: "border-color 0.2s ease",
          position: "relative",
          ...s && !i ? {
            ":hover": {
              background: e.white300
            }
          } : {}
        },
        children: /* @__PURE__ */ a("div", {
          css: {
            width: f,
            height: f,
            borderRadius: "50%",
            backgroundColor: s ? i ? e.slate300 : t ? e.black : e.blue500 : e.white200,
            position: "absolute",
            top: "50%",
            left: "50%",
            transition: "transform 280ms cubic-bezier(0.4, 0, 0.2, 1) 0s",
            transform: s ? "translate(-50%, -50%) scale3d(1, 1, 1)" : "translate(-50%, -50%) scale3d(0, 0, 0)"
          }
        })
      })
    }), /* @__PURE__ */ g("div", {
      css: {
        width: "100%"
      },
      children: [/* @__PURE__ */ a("p", {
        css: {
          ...u(),
          margin: 0
        },
        children: c
      }), b && /* @__PURE__ */ a("p", {
        css: {
          margin: 0,
          ...k()
        },
        children: b
      }), p && s && /* @__PURE__ */ a("div", {
        css: {
          paddingTop: 16
        },
        children: /* @__PURE__ */ a(y, {
          ...p
        })
      })]
    })]
  });
}
export {
  O as RadioInput
};
